import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, MapPin } from "lucide-react";
import { formatINR } from "@/lib/api";

export default function PackageCard({ pkg }) {
  return (
    <Link
      to={`/packages/${pkg.slug || pkg.id}`}
      data-testid={`package-card-${pkg.slug || pkg.id}`}
      className="card-flat block group"
    >
      <div className="img-frame aspect-[4/5]">
        <img
          src={pkg.hero_image}
          alt={pkg.title}
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 flex-wrap mb-2">
          <span className="chip">{pkg.category}</span>
          <span className="chip">
            <Clock className="w-3 h-3" /> {pkg.duration_days}D / {pkg.duration_nights}N
          </span>
        </div>
        <h3 className="font-heading text-2xl leading-tight">{pkg.title}</h3>
        <p className="text-sm text-[color:var(--brand-text-soft)] mt-1 flex items-center gap-1">
          <MapPin className="w-3.5 h-3.5" /> {pkg.destination}
        </p>
        <div className="rule my-4" />
        <div className="flex items-end justify-between">
          <div>
            <div className="overline">Starts from</div>
            <div className="flex items-baseline gap-2">
              <span className="font-heading text-2xl text-[color:var(--brand-text)]">
                {formatINR(pkg.price_inr)}
              </span>
              {pkg.original_price_inr &&
                pkg.original_price_inr > pkg.price_inr && (
                  <span className="text-xs line-through text-[color:var(--brand-text-soft)]">
                    {formatINR(pkg.original_price_inr)}
                  </span>
                )}
            </div>
            <span className="text-[11px] text-[color:var(--brand-text-soft)]">
              per person, twin sharing
            </span>
          </div>
          <div className="text-[color:var(--brand-primary)] flex items-center gap-1 text-sm font-medium">
            View <ArrowUpRight className="w-4 h-4" />
          </div>
        </div>
      </div>
    </Link>
  );
}
